import { Component } from '@angular/core';

import { ToastService } from './toast-service';
import { NgTemplateOutlet } from '@angular/common';
import { NgbToastModule } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'toast-container',
  templateUrl: './toast-container.component.html',
  styleUrls:['./toast-container.component.scss'],
  standalone: true,
  imports: [NgbToastModule, NgTemplateOutlet],
})
export class ToastsContainerComponent {
  constructor(protected toastService: ToastService) {
  }
}
